<template>
  <div class="gray-back">
    <div class="mine-box-title">认证首页</div>
    <div class="mine-content">
      <div class="flex-between mine-li"> 
        <div class="flex-start">
          <div class="info-row-title">单位认证</div>
        </div>
        <div class="flex-start">
          <div class="tishi">完成后可获得单位相关业务权限</div>
          <el-link type="primary" v-if="row.danwei.registstatus==0" v-rblink="{name:'CertDanweiApply'}">去认证</el-link>
          <el-link v-else-if="row.danwei.registstatus==3" v-rblink="{name:'CertDanweiResult'}">认证失败</el-link>
          <el-link v-else-if="row.danwei.registstatus==1" v-rblink="{name:'CertDanweiResult'}">审核中</el-link>
          <el-link v-else-if="row.danwei.registstatus==2" @click="unbind">解除认证</el-link>
        </div>
      </div>

      <div class="bottom-button">
        <el-button round type="default" v-rblink="{name:'YundongyuanList'}">运动员管理</el-button>
        <el-button round type="default" v-rblink="{name:'CaipanList'}">随队裁判员</el-button>
        <el-button round type="default" v-rblink="{name:'JiaolianList'}">随队教练员</el-button>
      </div>

      <div class="flex-between mine-li">
        <div class="flex-start">
          <div class="info-row-title">实名认证</div>
        </div>
        <div class="flex-start">
          <div class="tishi">关联实名信息，完成后可获得个人相关业务权限</div>
          <el-link type="primary" v-if="row.cert.status==0" @click="toShimin">去认证</el-link>
          <el-link v-else-if="row.cert.status==1" @click="unbindPerson">解除认证</el-link>
        </div>
      </div>

      <div class="mt10" v-if="row.cert.status==1">
          <el-tag effect="plain" type="success">已实名</el-tag> {{row.cert.user_name +' ' + row.cert.user_code}}
      </div>

      <div class="bottom-button" v-if="row.cert.status==1">
        <el-button round type="default" v-rblink="{name:'UserSearchCaipan'}">裁判员查询</el-button>
        <el-button round type="default" v-rblink="{name:'UserSearchJiaolian'}">教练员查询</el-button>
      </div>

      <div v-else>
          <div class="flex-start mt10">
            <div class="mr10">实名验证类型选择：</div>
            <el-radio-group v-model="numTypeName">
              <el-radio :label="item" v-for="item in numTypeColumns">{{item}}</el-radio>
            </el-radio-group>
          </div>
      </div>


      <div class="flex-between mine-li">
        <div class="flex-start">
          <div class="info-row-title">证件照管理 <el-tag v-if="row.photo.status==2" type="success" size="small">审核成功</el-tag> <el-tag v-if="row.photo.status==3" type="danger" size="small">审核失败</el-tag></div>
        </div>
        <div class="flex-start">
          <div class="tishi">裁判员、教练员等证书照片显示</div>
          <el-link type="primary" v-rblink="{name:'CertPersonPhoto'}">去管理</el-link>
        </div>
      </div>
    </div>

    <van-cell-group v-if="false">
      <van-cell title="实名认证" label="上传身份证信息，完成后自动关联运动员、裁判员、教练员数据" v-if="false">
        <template #right-icon>
          <div class="tiny-btn-1">去认证</div>
        </template>
      </van-cell>
      <van-cell title="家长认证" label="上传身份证明信息，完成后自动关联子女运动员信息" v-if="false">
        <template #right-icon>
          <div class="tiny-btn-1">管理</div>
        </template>
      </van-cell>
      <van-cell title="单位认证" label="关联CCA单位信息，完成后可获得单位相关业务权限" v-if="false">
        <template #right-icon>
          <div class="tiny-btn-1" v-if="row.danwei.registstatus==0" v-rblink="{name:'CertDanwei'}">去认证</div>
          <div class="tiny-btn-0" v-else-if="row.danwei.registstatus==3" v-rblink="{name:'CertDanweiResult'}">认证失败</div>
          <div class="tiny-btn-0" v-else-if="row.danwei.registstatus==1" v-rblink="{name:'CertDanweiResult'}">审核中</div>
          <div class="tiny-btn-0" v-else-if="row.danwei.registstatus==2" @click="unbind">解除认证</div>
        </template>
      </van-cell>
      <van-cell :value="row.danwei.name" v-if="row.danwei.registstatus==2">
        <template #icon>
          <van-tag plain type="success">已认证</van-tag>
        </template>
      </van-cell>

      <div class="bottom-button" v-if="false">
        <van-button round type="default" v-rblink="{name:'YundongyuanList'}">运动员管理</van-button>
        <van-button round type="default" v-rblink="{name:'CaipanList'}">裁判员管理</van-button>
        <van-button round type="default" v-rblink="{name:'JiaolianList'}">教练员管理</van-button>
      </div>
      <!--

      <van-cell title="考级中心/考级点"  label="注册或者关联考级中心考级点信息，获取七彩星级申报业务权限">
          <template #right-icon>
              <div class="tiny-btn-1" v-if="row.exame_center.kaojiregist_status==0" v-rblink="{name:'QcxjStationCert'}">去认证</div>
              <div class="tiny-btn-0" v-else-if="row.exame_center.kaojiregist_status==3" v-rblink="{name:'QcxjStationResult'}">认证失败</div>
              <div class="tiny-btn-0" v-else-if="row.exame_center.kaojiregist_status==1" v-rblink="{name:'QcxjStationResult'}">审核中</div>
          </template>
      </van-cell>
      <van-cell :value="row.exame_center.danwei"  v-if="row.exame_center.kaojiregist_status==2"  >
          <template #icon>
              <van-tag plain type="success">已认证</van-tag>
          </template>
      </van-cell>

      <div class="bottom-button">
          <van-button round type="default" v-rblink="{name:'ExameApplyList'}">七彩星级考级申报</van-button>
          <van-button round type="default" v-if="row.exame_center.kaojitype=='考级中心'" v-rblink="{name:'ExameApplySList'}">我授权的申报</van-button>
      </div>
      <van-cell title="我参加的七彩星级运动员申报"  is-link  v-rblink="{name:'ExameApplyJoinMemberList'}" >  </van-cell>
      <div style="height: 10px"></div>

      <van-cell title="CBA培训班"  label="七彩星级CBA及监督线上培训班申报">
      </van-cell>
      <div class="bottom-button">
          <van-button round type="default" v-rblink="{name:'CbaApplyFormBasic',query:{station_id:6}}">C级班</van-button>
          <van-button round type="default" v-rblink="{name:'CbaApplyFormBasic',query:{station_id:5}}">B级班</van-button>
          <van-button round type="default" v-rblink="{name:'CbaApplyFormBasic',query:{station_id:4}}">A级班</van-button>
      </div>
      <van-cell title="我的申报记录"  is-link  v-rblink="{name:'CbaApplyList'}" >  </van-cell>

      <van-cell title="俱乐部认证"  label="认证俱乐部资质，获取星级俱乐部权限">
          <template #right-icon>
              <div class="tiny-btn-1" v-if="row.club.registstatus==0" v-rblink="{name:'ClubApply'}">去认证</div>
              <div class="tiny-btn-0" v-else-if="row.club.registstatus==3" v-rblink="{name:'CertClubResult'}">认证失败</div>
              <div class="tiny-btn-0" v-else-if="row.club.registstatus==1" v-rblink="{name:'CertClubResult'}">审核中</div>
              <div class="tiny-btn-0" v-else-if="row.club.registstatus==2" @click="unbind">解除认证</div>
          </template>
      </van-cell>
      <van-cell :value="row.club.danwei"  v-if="row.club.registstatus==2"  >
          <template #icon>
              <van-tag plain type="success">已认证</van-tag>
          </template>
      </van-cell>
      <van-cell title="验收报告上传"  is-link  v-rblink="{name:'ClubApplyYanshou'}" >  </van-cell>
      <van-cell title="俱乐部建设订单"  is-link  v-rblink="{name:'ClubJiansheList'}" >  </van-cell>
      <div style="height: 10px"></div>
  -->
    </van-cell-group>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.bottom-button {
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  width: 100%;
  /*display: flex;*/
  /*flex: 1;*/
  /*flex-direction: row;*/
  /*justify-content: space-around;*/
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'StationApply',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      numTypeColumns: ['身份证', '护照','其他身份证明'],
      numTypeName: '身份证',
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {
        danwei: {},
        exame_center: {},
        club: {},
        cert: {
          status: 0
        },
        photo: {}
      },
      formData: {},
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "认证首页"
    this.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/certindex', {}, (res) => {
        that.row = res.data;
      }, (res) => {
        console.log('errrrrr')
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    unbind() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除单位认证吗?'
      }).then(() => {

        that.$api.post('/api/danwei/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },

    unbindPerson() {
      let that = this;
      that
          .$confirm("确认要解除个人认证吗?", "确认", {
            closeOnPressEscape: false,
            closeOnClickModal: false,
          })
          .then(() => {
            that.$api.post('/api/user/unbind', {}, (res) => {
              that.fetch();
            }, (res) => {

            })
          })
          .catch(() => {});
    },

    toShimin() {
      console.log("toShimin", this.numTypeName)
      let value = this.numTypeName
      let name = 'CertPersonApply'
      if(value != '身份证') {
        name = 'CertPersonApplyOther'
      }

      rbLink({
        name: name
      })
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// CertIndex.vue?c103168e